<template>
    <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600" persistent>
        <v-card>
            <v-btn icon absolute right class="close-btn" @click="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            
            <v-card-text class="py-0 px-0">
                <v-alert border="right" colored-border color="#8e84c0" elevation="0"
                    class="col-12 px-5 px-md-10 pt-7 pb-6 pt-md-9 pb-md-8 mb-0">
                    
                    <div class="text-left">
                        <h2 class="text-h5 font-weight-bold mb-2">{{ $t('harmony.layouts.selectYourTemplate') }}</h2>
                        <p class="subtitle-text mb-6">{{ $t('harmony.layouts.chooseTheDesignThatBestSuitsYourNeeds') }}</p>

                        <v-row>
                            <!-- Vista de Cuadrícula -->
                            <v-col cols="12" sm="6">
                                <v-card
                                    :class="['layout-option', { 'selected': selectedLayout === 'grid' }]"
                                    @click="selectedLayout = 'grid'"
                                    outlined
                                    hover
                                >
                                    <div class="layout-preview grid-preview">
                                        <div class="preview-header-small"></div>
                                        <div class="preview-grid">
                                            <div class="preview-grid-item"></div>
                                            <div class="preview-grid-item large"></div>
                                            <div class="preview-grid-item"></div>
                                            <div class="preview-grid-item"></div>
                                            <div class="preview-grid-item"></div>
                                            <div class="preview-grid-item"></div>
                                            <div class="preview-grid-item"></div>
                                        </div>
                                    </div>
                                    <v-card-text class="text-center py-4">
                                        <div class="font-weight-bold text-body-1 mb-1">{{ $t('harmony.layouts.gridView') }}</div>
                                        <div class="text-caption grey--text text--darken-1">{{ $t('harmony.layouts.masonryFlexibleDesign') }}</div>
                                    </v-card-text>
                                    <v-icon v-if="selectedLayout === 'grid'" class="check-icon" color="#8e84c0">
                                        mdi-check-circle
                                    </v-icon>
                                </v-card>
                            </v-col>


                            <!-- Vista de Lista -->
                            <v-col cols="12" sm="6">
                                <v-card
                                    :class="['layout-option', { 'selected': selectedLayout === 'list' }]"
                                    @click="selectedLayout = 'list'"
                                    outlined
                                    hover
                                >
                                    <div class="layout-preview list-preview">
                                        <div class="preview-header"></div>
                                        <div class="preview-item"></div>
                                        <div class="preview-item"></div>
                                        <div class="preview-item"></div>
                                        <div class="preview-footer">
                                            <div class="preview-footer-item"></div>
                                            <div class="preview-footer-item"></div>
                                        </div>
                                    </div>
                                    <v-card-text class="text-center py-4">
                                        <div class="font-weight-bold text-body-1 mb-1">{{ $t('harmony.layouts.listView') }}</div>
                                        <div class="text-caption grey--text text--darken-1">{{ $t('harmony.layouts.verticalAndOrganizedDesign') }}</div>
                                    </v-card-text>
                                    <v-icon v-if="selectedLayout === 'list'" class="check-icon" color="#8e84c0">
                                        mdi-check-circle
                                    </v-icon>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>

                    <v-row class="mt-6 mx-0" justify="end">
                        <v-btn text @click="close" class="mr-2 px-4">
                            {{ $t('harmony.layouts.cancel') }}
                        </v-btn>
                        <v-btn
                            style="background-color: #8e84c0; color: white;"
                            @click="confirmSelection"
                            :disabled="!selectedLayout"
                            class="px-6"
                            elevation="0"
                        >
                            {{ $t('harmony.layouts.confirmSelection') }}
                        </v-btn>
                    </v-row>
                </v-alert>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalLayouts",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        currentLayout: {
            type: String,
            default: 'grid'
        },
        harmony: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            selectedLayout: this.currentLayout,
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        currentLayout(newVal) {
            this.selectedLayout = newVal;
        },
        value(newVal) {
            if (newVal) {
                this.selectedLayout = this.currentLayout;
            }
        }
    },
    methods: {
        close() {
            this.dialog = false;
        },
        confirmSelection() {
            this.$emit('confirm', this.selectedLayout);
            this.close();
        },
    }
};
</script>

<style scoped>
.close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;
}

.subtitle-text {
    color: #978ace;
    font-size: 0.875rem;
    margin-bottom: 0;
}

.layout-option {
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    border: 3px solid #e0e0e0 !important;
    border-radius: 15px !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.layout-option:hover {
    border-color: #8e84c0 !important;
    box-shadow: 0 4px 12px rgba(142, 132, 192, 0.15);
}

.layout-option.selected {
    border: 3px solid #8e84c0 !important;
    box-shadow: 0 4px 12px rgba(142, 132, 192, 0.25);
}

.check-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    background: white;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.layout-preview {
    height: 250px;
    padding: 16px;
    background: #f9f9fc;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* Vista de Lista */
.list-preview .preview-header {
    height: 25px;
    background: #d8d4e8;
    border-radius: 8px;
}

.list-preview .preview-item {
    height: 45px;
    background: #d8d4e8;
    border-radius: 8px;
}

.list-preview .preview-footer {
    margin-top: auto;
    display: flex;
    gap: 8px;
}

.list-preview .preview-footer-item {
    flex: 1;
    height: 35px;
    background: #d8d4e8;
    border-radius: 8px;
}

/* Vista de Cuadrícula */
.grid-preview .preview-header-small {
    height: 18px;
    background: #d8d4e8;
    border-radius: 8px;
    margin-bottom: 8px;
}

.grid-preview .preview-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    flex: 1;
}

.grid-preview .preview-grid-item {
    background: #d8d4e8;
    border-radius: 8px;
}

.grid-preview .preview-grid-item.large {
    grid-row: span 2;
}
</style>

<style>
.v-dialog {
    border-radius: 25px !important;
}
</style>